import type { ConstantsMap } from "./options"
import { buildOptionsFromConstantsMap } from "./options"

export const CARD_SCHEMES_MAP = {
  Visa: {
    value: "Visa",
    label: "Visa",
  },
  Mastercard: {
    value: "Mastercard",
    label: "MasterCard",
  },
  Amex: {
    value: "Amex",
    label: "American Express",
  },
} as const satisfies ConstantsMap

export type CardScheme =
  (typeof CARD_SCHEMES_MAP)[keyof typeof CARD_SCHEMES_MAP]["value"]

const _options = buildOptionsFromConstantsMap(
  CARD_SCHEMES_MAP
)

export const useCardSchemeOptions = () => {
  return {
    options: _options,
    getLabelForValue: (value: CardScheme) =>
      _options.find((option) => option.value === value)
        ?.label || "",
  }
}
